export default "__VITE_PUBLIC_ASSET__d4b23c9a__"